import { render, staticRenderFns } from "./Tendency_singo.vue?vue&type=template&id=19fac5b3&scoped=true"
import script from "./Tendency_singo.vue?vue&type=script&lang=js"
export * from "./Tendency_singo.vue?vue&type=script&lang=js"
import style0 from "./Tendency_singo.vue?vue&type=style&index=0&id=19fac5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fac5b3",
  null
  
)

export default component.exports